import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-role-action',
  templateUrl: './role-action.component.html',
  styleUrls: ['./role-action.component.css']
})
export class RoleActionComponent implements OnInit {
  user:any;
  constructor() { }

  ngOnInit() {
    this.user = JSON.parse(sessionStorage.getItem("User"));
  }

}



// WEBPACK FOOTER //
// ./src/app/section/master/role-action/role-action.component.ts